import {ILocationProvider, module} from 'angular';

export default module('app.configs.routing', []).config(RoutingConfig);

/* @ngInject */
function RoutingConfig($locationProvider: ILocationProvider) {
    // Utiliser pushState de HTML5
    $locationProvider.html5Mode(true);
}
